import { Organisation } from 'app/shared/models/organisation.model';

export class TenantOffice {
    headOffice: Organisation;
    subOffices: Organisation[];
}



// WEBPACK FOOTER //
// ./src/app/shared/models/tenant-office.model.ts